import apiServiceNew from '_app/services/apiService.new';

const officePath = 'office';
const officePublicPath = 'officePublicInfo';

function getOfficeSettings(partnerId) {
	const url = `${officePath}/${partnerId}`;

	return apiServiceNew.get(url)
		.then(response => response.data);
}

function updateOfficeSettings(officeData) {
	const url = `${officePath}/${officeData.partnerID}`;

	return apiServiceNew.put(url, officeData);
}

function getPublicSettings(token, isCampaign = false) {
	const url = `${officePublicPath}/${token}?isCampaign=${isCampaign}`;

	return apiServiceNew.get(url)
		.then(response => response.data);
}

export default {
	get: getOfficeSettings,
	update: updateOfficeSettings,
	public: getPublicSettings
};